/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * auth module.
 */

import Vue from 'vue'

import {
  REGISTER,
  LOGIN,
  LOGOUT,
  SET_PERMISSIONS
} from './mutation-types'

export default {
  [LOGIN] (state, data) {
    state.authenticated = true
    state.idToken = data.idToken
    state.expiresAt = data.expiresAt
    // Set authorization header
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${data.idToken}`
  },

  [REGISTER] () {
    //
  },

  [LOGOUT] (state) {
    state.authenticated = false
    state.idToken = null
    state.expiresAt = null
    state.permissions = ['any']
    Vue.$http.defaults.headers.common.Authorization = ''
  },

  [SET_PERMISSIONS] (state, permissions) {
    if (Array.isArray(permissions)) {
      state.permissions = permissions
    } else if (permissions.indexOf('&') !== -1) {
      state.permissions = permissions.split('&')
    } else {
      state.permissions = [permissions]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js